export default __webpack_public_path__ + "static/media/AkashInstitute.ea1c0abb.png";